import { Minus, X } from "lucide-react";

export default function Titlebar({ name, post }) {
  return (
    <div
      className="flex items-center justify-between px-4 py-2 bg-[#0d0f16] border-b border-white/10 select-none"
      onMouseDown={(e) => e.target === e.currentTarget && post({ type: "drag" })}
      data-testid="launcher-titlebar"
    >
      <span className="font-display text-xs tracking-[0.3em] text-amber-300/80 uppercase pointer-events-none" data-testid="launcher-title">
        {name} · Launcher
      </span>
      <div className="flex gap-1">
        <button className="p-1.5 rounded hover:bg-white/10 text-slate-400 transition-colors" onClick={() => post({ type: "minimize" })} data-testid="launcher-minimize-btn">
          <Minus size={14} />
        </button>
        <button className="p-1.5 rounded hover:bg-red-600/70 text-slate-400 hover:text-white transition-colors" onClick={() => post({ type: "close" })} data-testid="launcher-close-btn">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
